import { DecimalPipe } from '@angular/common';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SiaNumberService {
  private decimalpipe = inject(DecimalPipe);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  formatDecimal(decimal: number, positions: number = 2): string | null {
    if (!decimal) {
      return '0';
    }
    var str: string | null = '';
    switch (positions) {
      case 0:
        str = this.decimalpipe.transform(decimal, '1.0-0');
        break;
      case 1:
        str = this.decimalpipe.transform(decimal, '1.1-1');
        break;
      case 2:
        str = this.decimalpipe.transform(decimal, '1.2-2');
        break;
      default:
        str = this.decimalpipe.transform(decimal, '1.2-2');
    }
    if (!str) return null;
    str = str
      .replace(/,/g, '#')
      .replace(/\./g, ',')
      .replace(new RegExp('#', 'g'), '.');
    return str;
  }

  formatInteger(integer: number): string | null {
    if (!integer) {
      return '0';
    }
    var str: string | null = this.decimalpipe.transform(integer, '1.0-0');
    if (!str) return null;
    str = str
      .replace(/,/g, '#')
      .replace(/\./g, ',')
      .replace(new RegExp('#', 'g'), '.');
    return str;
  }

  randomIntFromInterval(min: number, max: number) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
}
